/* eslint-disable */
import React, { useMemo,useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { CTitle, STitle } from '../../components/Widget';
import QRightBg from './../../../../../../assets/cybersecurity2026/topic1000/q_right_bg.png';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);


  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      <div className="tool-practice">
        <span /> <div>{paragraphsSettings.l2Title}</div>
      </div>
      <div className="issue-content">
        <div className="silder-list">
          {paragraphsSettings?.l2?.map((item: any, i: number) => (
            <div className="silder-list-item" key={i}>
              <div className="hexagon">{i + 1}</div>
              <div className="item-left">
                <h3>{item?.title}</h3>
                <p>{item?.content}</p>
              </div>
            </div>
          ))}
        </div>
        <img className="issue-content-bg" src={QRightBg} alt="" />
      </div>
    </div>
  );
};

export default Section2;
